export default __webpack_public_path__ + "static/media/joy_girl.251f97f9.png";